import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { isEmpty } from 'lodash';
import * as actions from "../../../store/actions";
import { i18n } from '../../../translate/i18n';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { toastr } from 'react-redux-toastr';

import {
  Paper, Tabs, Avatar, Button, Tab, Container, Drawer, Table, TableBody, TableCell, TableFooter, TablePagination, TableRow, Typography, CircularProgress, Badge, Chip,
} from '@mui/material';

import UserModalFilter from '../ModalFilter/Users/index';
import { FilterList, FileCopyOutlined } from '@mui/icons-material';
import EnhancedTableHead from "../../../UI/MaterialTableOverrides/EnhancedTableHead";
import TablePaginationActionsWrapped from "../../../UI/MaterialTableOverrides/TablePaginationActions";
import TableTitle from '../../../UI/MaterialTableOverrides/TableTitle';
import { roleNames, rolesText } from "../../../utils/roleNames";
import Spinner from '../../../components/Spinner/index';
import {selectFrontUrl} from '../../../axios/inviteLinkUrl';
import { formatLanguageFromLocalStorage } from "../../../utils/formatLanguageFromLocalStorage";

export default function TableUsers(props) {
  const dispatch = useDispatch();
  let textInput = useRef(null);

  const [alreadySerched, setAlreadySerched] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [firstLoad, setFirstLoad] = useState(true);
  const [pageUser, setPageUser] = useState(1);
  const [limitUser, setLimitUser] = useState(5);
  const [orderByUser, setOrderByUser] = useState("name");
  const [orderUser, setOrderUser] = useState("asc");

  const [pageUserInvitations, setPageUserInvitations] = useState(1);
  const [limitUserInvitations, setLimitUserInvitations] = useState(5);
  const [orderByUserInvitations, setOrderByUserInvitations] = useState("name");
  const [orderUserInvitations, setOrderUserInvitations] = useState("asc");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const [tabValue, setTabValue] = useState(0);

  const localStorageLang = localStorage.getItem("i18nextLng");
  const emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

  function handleChangeTab(event, newValue) {
    setTabValue(newValue);
  }

  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);
  const filteredRoles = useSelector(state => state.users.usersFilter.filteredRoles);

  const fetchUsers = useCallback(
    () => dispatch(actions.fetchUsers(pageUser, limitUser, searchText, orderUser, orderByUser, selectedSites, filteredRoles)),
    [pageUser, limitUser, searchText, orderUser, orderByUser, selectedSites, filteredRoles]
  );

  const fetchUsersInvitations = useCallback(
    () => dispatch(actions.fetchUsersInvitations(pageUserInvitations, limitUserInvitations, searchText, orderUserInvitations, orderByUserInvitations, selectedSites)),
    [pageUserInvitations, limitUserInvitations, searchText, orderUserInvitations, orderByUserInvitations, selectedSites]
  );

  const fetchUsersExport = useCallback(
    () => dispatch(actions.fetchUsersExport(searchText, orderUser, orderByUser, selectedSites, filteredRoles, emailLanguage)),
    [searchText, orderUser, orderByUser, selectedSites, filteredRoles, emailLanguage]
  );

  const users = useSelector(state => state.users.users);
  const usersInvitations = useSelector(state => state.users.usersInvitations);
  const usersFilter = useSelector(state => state.users.usersFilter);
  const loading = useSelector(state => state.users.loading);
  const loadingUsersInvitations = useSelector(state => state.users.loadingUsersInvitations);

  const headRows = [
    { id: "name", numeric: false, disablePadding: false, label: i18n.t('headRowsUsers.name') },
    { id: "email", numeric: false, disablePadding: false, label: i18n.t('headRowsUsers.email') },
    { id: "role", numeric: false, disablePadding: false, label: i18n.t('headRowsUsers.role') },
    { id: "site", numeric: false, disablePadding: false, label: i18n.t('headRowsUsers.site'), showSort: false },
    { id: "lastLogin", numeric: false, disablePadding: false, label: i18n.t('headRowsUsers.lastLogin') }
  ];

	const headRowsInvitations = [
    { id: "userDetails.email", numeric: false, disablePadding: false, label: i18n.t('headRowsInvitationsUsers.email') },
    { id: "role", numeric: false, disablePadding: false, label: i18n.t('headRowsInvitationsUsers.role') },
    { id: "site", numeric: false, disablePadding: false, label: i18n.t('headRowsInvitationsUsers.site') },
    { id: "createdAt", numeric: false, disablePadding: false, label: i18n.t('headRowsInvitationsUsers.createdAt') },
    { id: "invitation", numeric: false, disablePadding: false, label: i18n.t('headRowsInvitationsUsers.invitation') },
  ];

  useEffect(() => {
    if (!isEmpty(usersFilter)) {
      setPageUser(usersFilter.pageUser);
      setLimitUser(usersFilter.limitUser);
      setSearchText(usersFilter.searchText);
      setOrderUser(usersFilter.orderUser);
      setOrderByUser(usersFilter.orderByUser);
    }
    setFirstLoad(false);
  }, []);

	useEffect(() => {
		dispatch(actions.setOpenDrawer(true))
	}, [])

  useEffect(() => {
    if (!firstLoad) {
      fetchUsers(pageUser, limitUser, searchText, orderUser, orderByUser, selectedSites,filteredRoles);
      setAlreadySerched(true);
    }
  }, [firstLoad, pageUser, limitUser, orderUser, orderByUser])

  useEffect(() => {
    if (!firstLoad) {
      fetchUsers(pageUser, limitUser, searchText, orderUser, orderByUser, selectedSites, filteredRoles);
      setAlreadySerched(true);
      setPageUser(1)
    }
  }, [selectedSites,filteredRoles]);

  useEffect(() => {
    if (!firstLoad) {
      fetchUsersInvitations(pageUserInvitations, limitUserInvitations, searchText, orderUserInvitations, orderByUserInvitations, selectedSites);
    }
  }, [firstLoad, pageUserInvitations, limitUserInvitations, orderUserInvitations, orderByUserInvitations, selectedSites]);

  
  useEffect(() => {
    if (!firstLoad) {
      if (searchText !== "" || alreadySerched) {
        const timer = setTimeout(() => {
          if (searchText === textInput.current.value) {
            fetchUsers(pageUser, limitUser, searchText, orderUser, orderByUser);
            fetchUsersInvitations(pageUserInvitations, limitUserInvitations, searchText, orderUserInvitations, orderByUserInvitations);
          }
        }, 200);
        return () => {
          clearTimeout(timer);
        };
      }
    }
  }, [searchText, textInput]);

  const handleChangePageUser = (e, page) => {
    setPageUser(page + 1);
  };

  const handleChangeRowsPerPageUser = e => {
    setLimitUser(e.target.value);
    setPageUser(1);
  };

  const handleRequestSortUser = (event, property) => {
    const isDesc = orderByUser === property && orderUser === "desc";
    setOrderUser(isDesc ? "asc" : "desc");
    setOrderByUser(property);
  };

  const selectRow = (e, id) => {
    props.history.push(`form-user/${id}`)
  };

  const handleChangePageUserInvitations = (e, page) => {
    setPageUserInvitations(page + 1);
  };

  const handleChangeRowsPerPageUserInvitations = e => {
    setLimitUserInvitations(e.target.value);
    setPageUserInvitations(1);
  };

  const handleRequestSortUserInvitations = (event, property) => {
    const isDesc = orderByUserInvitations === property && orderUserInvitations === "desc";
    setOrderUserInvitations(isDesc ? "asc" : "desc");
    setOrderByUserInvitations(property);
  };

  const handleUrlLinkInvitation = (user) => {
    const functionality = user.functionality === "inviteAddTenant" ? "confirmaddtenant" : "confirmcreateuser";

    return (`${selectFrontUrl()}/${functionality}/${user._id}`);
  }

  const copyToClipboardNotification = () => toastr.info(i18n.t('linkInvitationUserCopiedToClipboard.toastr'), i18n.t('linkInvitationUserCopiedToClipboard.toastr1'))

  const styles = {
    table: {
      position: 'relative',
      marginBottom: 50,
    },
    opacityContainer: {
      opacity: loading ? '0.3' : '1',
    },
    tableRowActives: {
      cursor: 'pointer',
    },
    tableRowInvites: {
      cursor: 'auto',
    },
    linkIcon: {
      cursor: 'pointer',
    },
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      height: '100px',
    },
    editWidth: {
      width: '90%'
    },
    badge: {
      padding: '0 10px',
    },
    avatarSmallText: {
      fontSize: '0.75rem',
      width: '2.75rem',
      height: '2.75rem',
      marginRight: '0.25rem',
      marginLeft: '0.25rem',
    },
    cell: {
      fontSize: '0.775rem',
      padding: '0.25rem',
    },
    cellPhotoContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: '0.5rem',
    },
    dateContent: {
      display: 'flex',
      flexDirection: 'column',
    },
    expirationDate: {
      fontSize: '0.8rem',
      color: '#878787',
    },
    buttonFilterContainer: {
      display: 'flex',
      flexDirection: 'row',
      padding: '0px 20px 10px 20px',
    },
    buttonFilterIcon: {
      marginLeft: 5
    },
    buttonFilter: {
      zIndex: 200,
      backgroundColor: 'green',
      height: '2.2rem',
      width: '6.5rem',
      padding: '1rem',
      color: '#fff',
    },
    clearFilter: {
      cursor: 'pointer',
      textDecoration: 'underline',
      zIndex: 200,
      padding: '0.75rem 0.5rem',
      color: '#000',
    },
    filterContainer: {
      position: 'relative',
      width: '100%',
    },
    filterChipContainer: {
      paddingLeft: 20,
      display: 'flex',
      flexWrap: 'wrap',
    },
    filterChip: {
      cursor: 'pointer',
      margin: 5,
    },
  };

  const getHoursFromNow = (date, time, type) => {
		const dateExpiration = moment(date).add(time, type) 
		const hours = dateExpiration.diff(moment(new Date()), 'hours')
		const minutes = dateExpiration.diff(moment(new Date()), 'minutes')

		if (hours > 1) {
			return hours + i18n.t('getHoursFromNow.hours');
		} else if (minutes <= 60 && minutes > 0) {
			return minutes + i18n.t('getHoursFromNow.minutes');
		} else {
			return '-';
		}
  };
  const exportExcel = () => {
    setExportLoading(true);
    fetchUsersExport()
      .then(response => {
        if (response) {
          window.open(response.url, "_blank")
        }
        setExportLoading(false);
      })
      .catch(() => setExportLoading(false))
  }

  const clearFilterButton = () => {
    if ((filteredRoles && filteredRoles.length > 0))
      return <Typography onClick={handleClickClearFilters} style={styles.clearFilter}>{i18n.t('clearFilterButton.Typography')}</Typography>;
  };

  const handleClickClearFilters = () => {
    dispatch(actions.clearUsersFilter());
  };

  const deleteFilteredSite = (site) => {
    dispatch(actions.deleteFilteredSite(site))
  };

  const deleteFilteredRoles = (role) => {
    dispatch(actions.removeUsersRolesFilter(role));
  };
  
  const renderSitesChips = () => (selectedSites && selectedSites.map((site) => (<Chip
    key={site._id}
    label={site.name}
    onDelete={() => deleteFilteredSite(site)}
    style={styles.filterChip} />)))
  const renderRolesChips = () => (filteredRoles && filteredRoles.map((role) => (<Chip
    key={role.value}
    label={role.label}
    onDelete={() => deleteFilteredRoles(role)}
    style={styles.filterChip} />)))

  return <>
    <Drawer
      variant="temporary"
      anchor="right"
      onClose={() => setIsFilterOpen(false)}
      open={isFilterOpen}>
      <UserModalFilter
        closeModal={() => setIsFilterOpen(false)}
      />
    </Drawer>
    <Container maxWidth="lg">
      <Paper>
        <TableTitle
          title={i18n.t('tableTitleUser.title')}
          placeholder={i18n.t('tableTitleUser.placeholder')}
          inputRef={textInput}
          value={searchText}
          onChange={event => {
            setPageUser(1);
            setSearchText(event.target.value);
          }}
          addRow={() => props.history.push('form-user-new')}
          clickExport={exportExcel}
          downloading={exportLoading}
          exportButtonDisabled={loading}
        />
        <div style={styles.filterChipContainer}>
          <Button
            variant='contained'
            onClick={() => setIsFilterOpen(true)}
            style={styles.buttonFilter}>
            {i18n.t('buttonFilterUser.label')} <FilterList style={styles.buttonFilterIcon} />
          </Button>
          {renderSitesChips()}
          {renderRolesChips()}
          {clearFilterButton()}
        </div>
        <Tabs
          value={tabValue}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChangeTab}
          aria-label="disabled tabs example"
        >
          <Tab label={i18n.t('tabsUser.active')} />
          <Tab
            label={
              <Badge style={styles.badge} color="secondary" 
                badgeContent={usersInvitations.count}
              >
                {i18n.t('tabsUser.invite')}
              </Badge>
            }/>
        </Tabs>
        {tabValue === 0 && <Table style={styles.table}>
          <tbody>
            <tr>
              <td>
                {loading &&
                  <div style={styles.spinner}>
                    <Spinner />
                  </div>}
                {users.rows.length === 0 &&
                  <div style={styles.noResults}>
                    {!loading && <Typography style={styles.spinner}>{i18n.t('tabsUser.Typography')}</Typography>}
                  </div>}
              </td>
            </tr>
          </tbody>
          <EnhancedTableHead
            style={styles.opacityContainer}
            headRows={headRows}
            order={orderUser ? orderUser : 'asc'}
            orderBy={orderByUser ? orderByUser : 'name'}
            onRequestSort={handleRequestSortUser}
          />
          <TableBody style={styles.opacityContainer}>
            {users.rows.map((user, index) => (
              <TableRow
                style={styles.tableRowActives}
                key={user._id}
                hover
                onClick={event => selectRow(event, user._id)}>
                <TableCell style={styles.cell}>
                  <div style={styles.cellPhotoContainer}>
                    {user.photo ?
                      <Avatar src={user.photo.url} style={{ marginRight: 10, marginLeft: 5 }} /> :
                      <Avatar style={styles.avatarSmallText}>{i18n.t('tableCellUser.photo')}</Avatar>}
                    {user.name}
                  </div>
                </TableCell>
                <TableCell style={styles.cell}>{user.email}</TableCell>
                <TableCell style={styles.cell}>{user.access[0] && rolesText(user.access[0])}</TableCell>
                <TableCell style={styles.cell}>{user.access[0] && user.access[0].sites.map(site => <Chip style={styles.chip} key={site._id} label={site.name} />)}</TableCell>
                <TableCell style={styles.cell}>{user.lastLogin ? moment(user.lastLogin).format('DD/MM/YYYY HH:mm') : ''}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter style={styles.opacityContainer}>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                count={users.count}
                rowsPerPage={parseInt(limitUser)}
                page={pageUser - 1}
                SelectProps={{
                  native: true
                }}
                onPageChange={handleChangePageUser}
                onRowsPerPageChange={handleChangeRowsPerPageUser}
                ActionsComponent={TablePaginationActionsWrapped}
              />
            </TableRow>
          </TableFooter>
        </Table>}
        {tabValue === 1 &&
          <Table style={styles.table}>
            <tbody>
              <tr>
                <td>
                  {loadingUsersInvitations &&
                    <div style={styles.spinner}>
                      <CircularProgress />
                    </div>}
                  {usersInvitations.rows.length === 0 &&
                    <div style={styles.noResults}>
                      {!loadingUsersInvitations && <Typography style={styles.spinner}>{i18n.t('tableCellUser.Typography')}</Typography>}
                    </div>}
                </td>
              </tr>
            </tbody>
            <EnhancedTableHead
              style={styles.opacityContainer}
              headRows={headRowsInvitations}
              order={orderUserInvitations}
              orderBy={orderByUserInvitations}
              onRequestSort={handleRequestSortUserInvitations}
            />
            <TableBody style={styles.opacityContainer}>
              {usersInvitations.rows.map((user, index) => (
                <TableRow
                  style={styles.tableRowInvites}
                  key={user._id}>
                  <TableCell>{user.userDetails.email || user.userId.email}</TableCell>
                  <TableCell>{user.tenantDetails && roleNames(user.tenantDetails.role)} {user.tenantDetails.role === 'analist' && user.tenantDetails.documentTypes.length > 0 && `( ${user.tenantDetails.documentTypes.map(dcType => dcType.name)} )`}</TableCell>
                  <TableCell>{user.tenantDetails && user.tenantDetails.sites.map(site => <Chip style={styles.chip} key={site._id} label={site.name} />)}</TableCell>
                  <TableCell>
                    <div style={styles.dateContent}>
                      <span>{moment(user.createdAt).format('DD/MM/YYYY HH:mm')}</span>
                      <span style={styles.expirationDate}>{getHoursFromNow(user.createdAt, 3, 'day')}</span>
                    </div>
                  </TableCell>
                  <TableCell style={styles.linkIcon}><CopyToClipboard onCopy={copyToClipboardNotification} text={handleUrlLinkInvitation(user)}><FileCopyOutlined /></CopyToClipboard></TableCell>                
                </TableRow>
              ))}
            </TableBody>
            <TableFooter style={styles.opacityContainer}>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  count={usersInvitations.count}
                  rowsPerPage={parseInt(limitUserInvitations)}
                  page={pageUserInvitations - 1}
                  SelectProps={{
                    native: true
                  }}
                  onPageChange={handleChangePageUserInvitations}
                  onRowsPerPageChange={handleChangeRowsPerPageUserInvitations}
                  ActionsComponent={TablePaginationActionsWrapped}
                />
              </TableRow>
            </TableFooter>
          </Table>
        }
      </Paper>
    </Container>
  </>;

}



